<template>
    <div class="container my-2">
        <div id="debug-info" style="position: fixed; z-index: 9999; top: 80px; right: 10px;" v-if="1 == 0">
            CNPJ: {{ cnpjSelecionado || 'Nenhum' }} <br>
            Inscrição Municipal: {{ contribuinte.inscricaoMunicipal || 'Nenhuma' }} <br>
            Filtro Data Mínima: {{ filtros.dataMinima || 'Nenhum' }} <br>
            Filtro Data Máxima: {{ filtros.dataMaxima || 'Nenhum' }} <br>
            Filtro Inscrição Municipal: {{ filtros.inscricaoMunicipal || 'Nenhuma' }} <br>
            Filtro Responsável: {{ filtros.responsavel || 'Nenhum' }} <br>
        </div>
        <div style="text-align: center">
            <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>
        <!-- Mensagens de Sucesso e Erro -->
        <!-- <mensagemAlerta :mensagens="mensagemSucesso" />
        <mensagemAlerta :mensagens="mensagemErro" />´ -->
        <div v-if="mensagemSucesso">
            <div v-for="i in mensagemSucesso" :key="i">
            <b-alert show variant="success" dismissible>
                <b-icon variant="success" icon="check" />
                {{ i }}
            </b-alert>
            </div>
        </div>

        <div v-if="mensagemErro">
            <div v-for="i in mensagemErro" :key="i">
            <b-alert show variant="danger" dismissible>
                <b-icon variant="danger" icon="x-circle-fill" />
                {{ i }}
            </b-alert>
            </div>
        </div>        
        <!-- -->
        <div v-if="logadoGovBr">
            <form @submit.prevent>
                <h2 class="title">Selecionar Inscrição</h2>

                <b-card class="mb-4">
                    <!-- Formulário de Contribuinte -->
                    <formResponsavelEmpresa :responsavel="contribuinte" :cnpj="cnpj" />
                    <!-- -->
                </b-card>
                <b-card>
                    <tabelaListagemCNPJ :rows="cnpjsRelacionadosTabela"
                        :forca-limpar-campos="forcaLimparCamposListagemCnpj" @update:selecionado="(values) => {
                            if (!values) return;
                            if (!values.dadosEstabelecimentoSelecionado) return;
                            values = values.dadosEstabelecimentoSelecionado;
                            if (!values.codigoNacional) return;
                            this.cnpjRelacionadoFoiSelecionado = true;
                            this.desabilitaIdentificador = true;
                            this.cnpjSelecionado = values.codigoNacional;
                        }" />

                    <b-row class="float-right mt-3 mr-3">
                        <b-col sm="6">
                            <b-button variant="outline-secondary" @click="limpar">Limpar</b-button>
                        </b-col>
                        <b-col sm="6">
                            <b-button variant="primary" @click="pesquisar"
                                :disabled="cnpjSelecionado === '' || listaInscricaoMunicipal.length > 0">Pesquisar</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </form>
        </div>
    <div v-else>
        <form @submit.prevent>
          <div class="">
            <b-card>
            <b-card class="ml-0" style="width: 100%">
              <span
                class="title h5"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Pesquisar empresas ligadas ao CPF."
              >
                Dados do contribuinte
                <b-icon
                  variant="primary"
                  icon="info-circle-fill"
                  class="ml-2"
                />
              </span>

              <b-row class="mb-3 mt-4">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="3" md="3" clas="ml-2" lg="1" align-self="center">
                  <label for="cpf" class="pb-3">CNPJ</label>
                </b-col>
                <b-col sm="8" md="4" class="ml-4" align-self="start">
                  <b-form-input
                    id="cpfCnpj"
                    class="ml-0"
                    v-mask="['XX.XXX.XXX/XXXX-##']"
                    v-model="CNPJinformado"
                    @keyup="validacaoCNPJ()"
                  >
                  </b-form-input>
                  <small
                    id="cpfCnpj"
                    :class="erroValidacaoCNPJ"
                    class="ml-3 form-text"
                  >
                    {{ mensagemValidacaoCNPJ }}
                  </small>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="0" md="0"> </b-col>
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="0" align-self="end" style="padding-rigth=0px">
                  <label for="NomeFantasia">Nome Fantasia</label>
                </b-col>
                <b-col sm="8" style="padding-left=0px" align-self="start">
                  <b-form-input id="NomeFantasia" class="ml-2" disabled v-model="cnpj.nome">
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1 mt-3 float-right">
                <b-col sm="4" class="mr-3">
                  <b-button variant="outline-secondary" @click="limparCNPJ">
                    Limpar
                  </b-button>
                </b-col>
                        <b-col sm="6">
                            <b-button variant="primary" @click="pesquisar"
                                :disabled="CNPJinformado.length !== 18">Pesquisar</b-button>
                        </b-col>
              </b-row>
            </b-card>
            </b-card>
          </div>
</form>
</div>
        <b-card v-if="exibirTabelaConfissoes === true" class="mt-4">
            <div>
                <h2 class="title">Confissões Anteriores</h2>
                <b-card class="mt-3">
                    <b-row class="mb-3 align-items-center">
                        <b-col sm="auto" class="pr-0">
                            <label for="dataMinima" class="mb-0">Inscrição Municipal:</label>
                        </b-col>
                        <b-col sm="auto" class="pl-2">
                            <select name="inscricaoMunicipal" id="inscricaoMunicipal"
                                v-model="filtros.inscricaoMunicipal" @change="construirTabelaExibicao()">
                                <option value=""> - </option>
                                <option v-for="opcao in listaInscricaoMunicipal" :key="opcao.value"
                                    :value="opcao.value">{{ opcao.text.replace('INSCRIÇÃO MUNICIPAL: ', '') }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3 align-items-center">
                        <b-col sm="auto" class="pr-0">
                            <label for="dataMinima" class="mb-0">Responsável:</label>
                        </b-col>
                        <b-col sm="auto" class="pl-2">
                            <select name="responsavel" id="responsavel" v-model="filtros.responsavel"
                                @change="construirTabelaExibicao()">
                                <option value=""> - </option>
                                <option v-for="opcao in filtros.responsaveis" :key="opcao" :value="opcao">{{
                                    formatarNome(opcao) }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3 align-items-center">
                        <b-col sm="auto" class="pr-0">
                            <label for="dataMinima" class="mb-0">Data mínima:</label>
                        </b-col>
                        <b-col sm="auto" class="pl-2">
                            <input type="date" name="dataMinima" id="dataMinima" class="form-control" style="
                                    width:auto; 
                                    display:inline-block;
                                    padding-right: 15px;" v-model="filtros.dataMinima"
                                @change="construirTabelaExibicao()">
                        </b-col>
                        <b-col sm="auto" class="pr-0 pl-3">
                            <label for="dataMaxima" class="mb-0">Data máxima:</label>
                        </b-col>
                        <b-col sm="auto" class="pl-2">
                            <input type="date" name="dataMaxima" id="dataMaxima" class="form-control" style="
                                    width:auto; 
                                    display:inline-block;
                                    padding-right: 15px;" v-model="filtros.dataMaxima"
                                @change="construirTabelaExibicao()">
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end align-items-center mb-2">
                        Exibir
                        <select v-model="exibicaoConfissoes.itensPorPagina" @change="construirTabelaExibicao()"
                            style="margin: 3px; width: 70px;">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                        </select>
                        Linhas
                    </div>
                    <b-table id="confissoes-anteriores" striped hover :items="exibicaoConfissoes.listaConfissesExibicao"
                        :fields="[
                            { key: 'Codigo_de_Lancamento', label: 'Código do Lançamento', sortable: true },
                            { key: 'data', label: 'Data', sortable: true },
                            { key: 'responsavel', label: 'Responsável', sortable: true },
                            { key: 'cpfResponsavel', label: 'CPF do Responsável', sortable: true },
                            { key: 'acoes', label: 'Reemitir Termo', class: 'text-center' }
                        ]" :per-page="exibicaoConfissoes.itensPorPagina" :current-page="exibicaoConfissoes.paginaAtual"
                        show-empty empty-text="Nenhuma confissão encontrada" :sort-by.sync="exibicaoConfissoes.sortBy"
                        :sort-desc.sync="exibicaoConfissoes.sortDesc" :sort-direction="exibicaoConfissoes.sortDirection"
                        :sort-compare="sortCompare">
                        <template #cell(Codigo_de_Lancamento)="data">
                            {{ formataCodigoDeLancamento(data.value) }}
                        </template>
                        <template #cell(responsavel)="data">
                            {{ formatarNome(data.value) }}
                        </template>
                        <template #cell(cpfResponsavel)="data">
                            {{ formatarCPF(data.value) }}
                        </template>
                        <template #cell(acoes)="data">
                            <b-button variant="outline-primary" @click="reemitirTermo(data.item)">Reemitir</b-button>
                        </template>
                    </b-table>
                    <b-pagination v-model="exibicaoConfissoes.paginaAtual"
                        :total-rows="exibicaoConfissoes.listaConfissesExibicao.length"
                        :per-page="exibicaoConfissoes.itensPorPagina" aria-controls="confissoes-anteriores"
                        align="right"></b-pagination>
                </b-card>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";    
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import tabelaListagemCNPJ from "../components/compartilhados/tabelaListagemCNPJ.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
// import dayjs from "dayjs";
// import mensagemAlerta from "../components/mensagemAlerta.vue";
import formResponsavelEmpresa from "../components/formResponsavelEmpresa.vue";
import { validarCNPJ } from '@at-siatu-tributario/tipo-identificador';
// import validarCNPJ from "../validations";

export default {
    name: 'USC.21.018',
    components: {
        loading,
        tabelaListagemCNPJ,
        // mensagemAlerta,
        formResponsavelEmpresa,
    },
    directives: {
        mask,
    },
    data() {
        return {
            carregando: false,
            mensagemSucesso: [],
            mensagemErro: [],
            contribuinte: {
                cpf: "",
                nome: "",
                inscricaoMunicipal: "",
                idPessoa: "",
                idPessoaPapel: "",
            },
            cnpj: {
                valor: "",
                nome: "",
            },
            forcaLimparCamposListagemCnpj: false,
            cnpjRelacionadoFoiSelecionado: false,
            cnpjsRelacionadosTabela: [],
            cnpjSelecionado: "",
            listaInscricaoMunicipal: [],
            listaConfissoesAnteriores: [],
            exibicaoConfissoes: {
                listaConfissesExibicao: [],
                itensPorPagina: 10,
                paginaAtual: 1,
                totalPaginas: 0,
                sortBy: "data",
                sortDirection: "desc", // Pode ser 'asc' ou 'desc'
                sortDesc: true, // Para manter a compatibilidade com o sortBy.sync
            },
            filtros: {
                dataMinima: null,
                dataMaxima: null,
                responsaveis: [],
                responsavel: "",
                inscricoesMunicipais: [],
                inscricaoMunicipal: "",
            },
            exibirSelecaoISSQN: false,
            exibirTabelaConfissoes: false,
            existeCnpjRelacionado: false,

            logadoGovBr: false,
            CNPJinformado: "",
            mensagemValidacaoCNPJ: "",
            erroValidacaoCNPJ: "",
            preencheCnpjOK: false,
        };
    },
    computed: {
        // Defina suas propriedades computadas aqui
    },
    async beforeCreate() {
        const logado =
            this.$store.getters.userInfo.origem === "GovBr" ||
            this.$store.getters.userInfo.origem === "AD";
        if (!logado) this.$router.push({ name: "Home" });
    },
    async beforeMount() {
        this.logadoGovBr = this.$store.getters.userInfo.origem === "GovBr";
        if (this.logadoGovBr) {
            this.contribuinte.cpf = this.$store.getters.userInfo.preferred_username;
            this.contribuinte.nome = this.$store.getters.userInfo.name;

            await this.buscarCNPJRelacionados();
        }
    },

    watch: {
        CNPJinformado(newValue) {
            if (newValue.length !== 18) {
                this.exibirTabelaConfissoes = false;  
            } 
        },
    },

    methods: {
        validacaoCNPJ: function () {
        let tamCampo = 0;
        let txt = "";
        let formato = "";
        let tipo = this.CNPJinformado.length;

        this.preencheCnpjOK = false;

        //CPF
        if (tipo <= 18) {
            //CNPJ
            tamCampo = 18;
            txt = "CNPJ";
        }

        if (this.CNPJinformado.length <= tamCampo) {
            this.mensagemValidacaoCNPJ = txt + " digitado está incompleto";
            formato = "text-danger";
            this.preencheCpfdOK = false;
        }
        if (tipo == 18) {
            if (validarCNPJ(this.CNPJinformado)) {
            this.mensagemValidacaoCNPJ = txt + " digitado é válido";
            formato = "text-success";
            this.preencheCnpjOK = true;
            } else {
            this.mensagemValidacaoCNPJ = txt + " - dígito verificador inválido";
            formato = "text-danger";
            this.preencheCnpjOK = false;
            }
        }
        this.erroValidacaoCNPJ = formato;

        if (this.CNPJinformado === "") {
            this.mensagemValidacaoCNPJ = "";
        }
        },        
        // Defina seus métodos aqui
        async buscarCNPJRelacionados() {
            try {
                this.carregando = true;
                this.mensagemErro = [];
                await this.$axios.get(`${this.$env.url_backend}/v1/espontaneo`).then((response) => {
                    const informacoesUsuario = response.data ? response.data.informacoesUsuario : null;
                    this.contribuinte.idPessoa = informacoesUsuario ? informacoesUsuario.ID_PESSOA : null;
                    this.existeCnpjRelacionado = response.data.cnpjsRelacionados.listaEstabelecimento.length > 0; 
                    this.cnpjsRelacionadosTabela = response.data.cnpjsRelacionados.listaEstabelecimento.map((valor) => {
                        return {
                            cnpj: valor.cnpj,
                            cnpj_limpo: valor.cnpj.replace(/[^\d\w]+/g, ""),
                            nome: valor.nome,
                            selecionado: false,
                        };
                    });
                });
                if (!this.existeCnpjRelacionado){
                    const mens =  "Não foi encontrado CNPJ relacionado para este CPF.";
                    this.mensagemErro.push(mens);
                    window.scrollTo(0, 0);            
                }                
            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
                window.scrollTo(0, 0);
            } finally {
                this.carregando = false;
            }
        },

        async pesquisar() {
            try {
                this.carregando = true;
                this.mensagemSucesso = [];
                this.mensagemErro = [];

                const usuario = this.$store.getters.userInfo.origem;

                let cnpj = "";
                let cpfResponsavel = "";

                if (this.logadoGovBr) {
                    cnpj = this.cnpjSelecionado;
                    cpfResponsavel = this.contribuinte.cpf;
                } else {
                    cnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");
                    ///
                    const pTipoIdentificador = '4';
                    const pIdentificador = cnpj;
                    await this.$axios
                        .post(`${this.$env.url_backend}/v1/espontaneo/endereco-gov`, {
                            pTipoIdentificador,
                            pIdentificador
                        })
                        .then((response) => {
                            const dados = response.data.resultado;
                            if (dados) {
                                this.cnpj.nome = dados.RAZAO_SOCIAL;
                            } else {
                                this.cnpj.nome = "";
                            }
                        });
                    ///
                }

                await this.$axios.post(`${this.$env.url_backend}/v1/espontaneo/confissoes-anteriores`, { cnpj }).then((response) => {
                    this.listaConfissoesAnteriores = response.data.resultado;
                    for (const confissao of this.listaConfissoesAnteriores) {
                        if (!this.filtros.inscricoesMunicipais.includes(confissao.INSCRICAO_MUNICIPAL)) {
                            this.filtros.inscricoesMunicipais.push(confissao.INSCRICAO_MUNICIPAL);
                        }
                        if (!this.filtros.responsaveis.includes(confissao.NOME_RESPONSAVEL)) {
                            this.filtros.responsaveis.push(confissao.NOME_RESPONSAVEL);
                        }
                    }
                    this.construirTabelaExibicao();
                });

                await this.$axios.post(`${this.$env.url_backend}/v1/espontaneo/inscricao-municipal`, { cnpj, cpfResponsavel, usuario }).then((response) => {
                    this.inscricaoMunicipal = response.data.inscricaoMunicipal;
                    if (this.inscricaoMunicipal.length !== 0) {
                        this.listaInscricaoMunicipal = this.inscricaoMunicipal.map((x) => {
                            return {
                                value: x.identificador,
                                text: `Inscrição Municipal: ${x.identificador} - ${x.endereco}`.toUpperCase(),
                            };
                        });
                    }
                    this.cnpj = {
                        valor: cnpj,
                        nome: this.inscricaoMunicipal &&
                            this.inscricaoMunicipal.length > 0 ?
                            this.inscricaoMunicipal[0].nome :
                            null,
                    };
                });

                if (this.listaConfissoesAnteriores.length === 0) {
                    this.exibirTabelaConfissoes = false;
                    this.limpar();
                    this.mensagemErro.push("Nenhum Termo de Confissão encontrado");
                    // Rola para a mensagem de erro após exibir
                    window.scrollTo(0, 0);
                } else {
                    this.exibirTabelaConfissoes = true;
                    // Rola para a tabela após exibir
                    this.gotoElementById('confissoes-anteriores');
                }

            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
                window.scrollTo(0, 0);
            } finally {
                this.carregando = false;
            }
        },
        construirTabelaExibicao() {
            let dataMinima = null;
            if (typeof this.filtros.dataMinima === "string" && this.filtros.dataMinima) {
                // Ajusta para GMT-3 (Brasília) ao criar a data mínima
                const [ano, mes, dia] = this.filtros.dataMinima.split('-');
                dataMinima = new Date(Date.UTC(ano, mes - 1, dia, 3, 0, 0));
            }

            let dataMaxima = null;
            if (typeof this.filtros.dataMaxima === "string" && this.filtros.dataMaxima) {
                // Ajusta para GMT-3 (Brasília) ao criar a data máxima (final do dia)
                const [ano, mes, dia] = this.filtros.dataMaxima.split('-');
                dataMaxima = new Date(Date.UTC(ano, mes - 1, dia, 26, 59, 59, 999));
            }
            const listaConfissoesAnteriores = this.listaConfissoesAnteriores.filter((confissao) => {
                // Filtra as confissões de acordo com os filtros de data, se definidos
                if (dataMinima && confissao.DATA_CONFISSAO < dataMinima) {
                    return false;
                }
                if (dataMaxima && confissao.DATA_CONFISSAO > dataMaxima) {
                    return false;
                }
                if (this.filtros.responsavel && confissao.NOME_RESPONSAVEL !== this.filtros.responsavel) {
                    return false;
                }
                if (this.filtros.inscricaoMunicipal && confissao.INSCRICAO_MUNICIPAL !== this.filtros.inscricaoMunicipal) {
                    return false;
                }
                return true;
            }).sort((a, b) => {
                // Ordena por data de confissão, do mais recente para o mais antigo
                return new Date(b.DATA_CONFISSAO) - new Date(a.DATA_CONFISSAO);
            });
            const itensPorPagina = this.exibicaoConfissoes.itensPorPagina;
            const paginaAtual = this.exibicaoConfissoes.paginaAtual - 1; //Alterando para 0-indexed

            this.exibicaoConfissoes.listaConfissesExibicao = []; // Limpa a lista antes de construir novamente
            for (let i = 0; i < listaConfissoesAnteriores.length; i++) {
                if (i < paginaAtual * itensPorPagina) {
                    //continue; // Se o índice for menor que o início da página, não adiciona na exibição
                } else if (i > (paginaAtual * itensPorPagina + itensPorPagina - 1)) {
                    //break; // Se o índice for maior que o limite da página, não adiciona
                }

                const confissao = listaConfissoesAnteriores[i];
                confissao.DATA_CONFISSAO = new Date(confissao.DATA_CONFISSAO);
                this.exibicaoConfissoes.listaConfissesExibicao.push({
                    Codigo_de_Lancamento: confissao.CODIGO_LANCAMENTO,
                    data: this.formatarData(new Date(confissao.DATA_CONFISSAO)),
                    responsavel: confissao.NOME_RESPONSAVEL,
                    cpfResponsavel: confissao.CPF_RESPONSAVEL,
                    reemitir_termo: this.$env.url_cobranca + '/emissor/termo_confissao_denuncia_esp?id=' + confissao.argumentoUrlCobranca
                });
            }

        },
        gotoElementById(id) {
            this.$nextTick(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },
        sortCompare(a, b, key) {
            // Ordenação customizada para cada coluna
            if (key === 'Codigo_de_Lancamento') {
                return parseInt(a[key]) > parseInt(b[key]);
            }
            if (key === 'data') {
                const [diaA, mesA, anoA] = a[key].split("/");
                const [diaB, mesB, anoB] = b[key].split("/");
                // const aDate = `${anoA}-${mesA}-${diaA}`;
                const dateA = new Date(anoA, mesA - 1, diaA);
                // const bDate = `${anoB}-${mesB}-${diaB}`;
                const dateB = new Date(anoB, mesB - 1, diaB);
                return dateA - dateB;
            }
            return a[key] > b[key];
        },
        async reemitirTermo(item) {
            try {
                const codigoLancamento = item.Codigo_de_Lancamento;
                await this.$axios.post(`${this.$env.url_backend}/v1/espontaneo/download-termo`, { codigoLancamento }, { responseType: "blob" }).then((response) => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `termo_confissao_${codigoLancamento}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                });
            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
                window.scrollTo(0, 0);
            }

        },
        formatarData(valor) {
            return valor.toLocaleString("pt-BR", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
            });
        },
        formatarCPF(cpf) {
            if (!cpf) return "";
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        },
        formataCodigoDeLancamento(codigo) {
            if (!codigo) return "";
            return codigo.replace(/(\d{2})(\d{3})(\d{2})(\d{7})/, "$1.$2.$3.$4");
        },
        formatarNome(nome) {
            if (!nome) return "";
            return nome.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
                .replace(/([a-z])([A-Z])/g, (match, p1, p2) => p1 + " " + p2)
                .replace(/\s+/g, " ")
                .trim();
        },

        limparCNPJ: function () {
            this.mensagemValidacaoCNPJ = "";
            this.CNPJinformado = "";
            this.cnpj.nome = "";
            this.listaInscricaoMunicipal = [];
            this.preencheCnpjOK = false;
            this.limpar();
                }, 

        limpar() {
            this.mensagemSucesso = [];
            this.mensagemErro = [];
            this.exibirSelecaoISSQN = false;
            this.cnpjRelacionadoFoiSelecionado = false;
            // this.cnpjSelecionado = "";
            this.contribuinte.inscricaoMunicipal = "";
            this.listaInscricaoMunicipal = [];
            this.listaConfissoesAnteriores = [];
            this.exibirTabelaConfissoes = false;
            this.filtros = {
                dataMinima: null,
                dataMaxima: null,
                responsaveis: [],
                responsavel: "",
                inscricoesMunicipais: [],
                inscricaoMunicipal: "",
            };
        },
    },
}
</script>